import PlatformSwitcher from '@/components/config_components/PlatformSwitcher/PlatformSwitcher.vue'
import UserProfileModal from '@/components/config_components/UserProfileModal/UserProfileModal.vue'
import { userProfileModalMixin } from '@/components/config_components/UserProfileModal/user_profile_modal_mixin'
import * as onboarding_journey_filter_service from '@/services/onboarding_journey_filter_service'

function get_initials(name = '') {
  return String(name || '')
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase() || 'U';
}

export default {
  name: 'ConfigNavbar',
  mixins: [userProfileModalMixin],
  props: {
    show_mobile_ai_drawer: {
      type: Boolean,
      default: false
    }
  },
  components: { PlatformSwitcher, UserProfileModal },
  computed: {
    is_onboarding_system() {
      return Boolean(this.$route.meta?.onboardingSystem);
    },
    is_aic_one_login() {
      return String(sessionStorage.getItem('is_aic_one_login') || '').toLowerCase() === 'true';
    },
    onboarding_section() {
      return this.$route.meta?.onboardingSection || 'Overview';
    },
    onboarding_title() {
      return this.$route.meta?.onboardingTitle || 'Command centre';
    },
    current_onboarding_journey_label() {
      return onboarding_journey_filter_service.resolve_onboarding_journey_filter(this.$route).label || 'All Journeys';
    },
    user_name() {
      return this.$store.getters.currentLeadName || 'User';
    },
    role() {
      return this.$store.getters.currentRole || '';
    },
    is_applicant_role() {
      return String(this.role || '').trim().toLowerCase() === 'entity';
    },
    show_new_onboarding_action() {
      return this.is_onboarding_system;
    },
    user_initials() {
      return get_initials(this.user_name);
    }
  },
  methods: {
    sign_out() {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('otp_verified');
      sessionStorage.removeItem('is_aic_one_login');
      sessionStorage.removeItem('auth_redirect_reason');
      sessionStorage.removeItem('user_id');
      this.$store.dispatch('resetStore');
      this.$router.push({ name: 'UserLogin' });
    }
  }
}
